import HttpClient from "@/common/boot/HttpClient"

const listarEstados = async ({ commit }, payload) => {

  commit('CARREGANDO', true);

  await HttpClient.get('/gestao-producao/estados', payload).then(response => {
      commit('LISTAR_DADOS', response.data.data);
      return response;
  });

  commit('CARREGANDO', false);
}

export {
  listarEstados
}